import React from 'react';

import { Box } from '@mui/material';

import { LogoContainer, TopBar } from '../../common';

import styles from './TopSection.module.scss';

export const TopSection: React.FC = () => {
  return (
    <Box className={styles.wrapper} component="nav">
      <TopBar>
        <LogoContainer className={styles.logo} />
      </TopBar>
    </Box>
  );
};
